export const AUTH_STORAGE_KEY = "eusebionews_admin_tokens";

export interface StoredTokens {
  access: string;
  refresh: string;
}

export function loadTokens(): StoredTokens | null {
  try {
    const raw = localStorage.getItem(AUTH_STORAGE_KEY);
    return raw ? (JSON.parse(raw) as StoredTokens) : null;
  } catch {
    return null;
  }
}

export function saveTokens(tokens: StoredTokens | null) {
  if (tokens) {
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(tokens));
  } else {
    localStorage.removeItem(AUTH_STORAGE_KEY);
  }
}

let accessToken: string | null = loadTokens()?.access ?? null;
let refreshToken: string | null = loadTokens()?.refresh ?? null;

export function getAccessToken() {
  return accessToken;
}

export function getRefreshToken() {
  return refreshToken;
}

export function setAuthTokens(access: string | null, refresh: string | null) {
  accessToken = access;
  refreshToken = refresh;
  if (access && refresh) {
    saveTokens({ access, refresh });
  } else {
    saveTokens(null);
  }
}

export function getAuthTokens() {
  return { access: accessToken, refresh: refreshToken };
}
